<template>
	<div>
		<div class="top-form">
			<el-form :inline="true">
				<el-row>
					<el-col :span="12">
						<el-form-item label="车间选择">
							<el-select v-model="workshopId" clearable placeholder="车间选择">
								<el-option v-for="item in workshops" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12" style="text-align:right;">
						<template v-if="timerVisible">
							<el-form-item label="刷新周期">
								<el-input-number v-model="cycle" :min="10" :max="60" label="刷新周期"></el-input-number>
							</el-form-item>
							<el-form-item>
								<el-button type="info" @click="handleMonitor">设置</el-button>
							</el-form-item>
						</template>
					</el-col>
				</el-row>
			</el-form>
		</div>

		<device-list v-bind:workshopId="workshopId" v-on:select="handleSelectJT" />
	</div>
</template>

<script>
	import dictionaryData from '@/service/dictionaryData'
	import DeviceList from './DeviceList'
	export default {
		components: {
			DeviceList,
		},
		data() {
			return {
				workshopId: '',
				workshops: [],
				cycle: 10,
			}
		},
		props: {
			timerVisible: {
				type: Boolean,
				default: true,
			},
		},
		methods: {
			/**
			 * 选择机台。
			 */
			handleSelectJT(jt_info) {
				this.$emit('select', jt_info)
			},
			handleMonitor() {
				window.localStorage.setItem('MonitorTime', this.cycle)
			},
		},
		async created() {
			this.workshops = await dictionaryData.getWorkshops()
			var monitorTime = window.localStorage.getItem('MonitorTime')
			if (monitorTime) {
				this.cycle = monitorTime
			}
		},
	}
</script>

<style scoped>
	.top-form {
		background-color: #f5f5f5;
		padding: 20px 20px 0 20px;
		margin-left: -19px;
		margin-right: -20px;
		margin-top: 20px;
		border-bottom: 1px #eee solid;
	}
</style>
